import { render, staticRenderFns } from "./noticeTime.vue?vue&type=template&id=15ade0fa&"
import script from "./noticeTime.vue?vue&type=script&lang=js&"
export * from "./noticeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports